import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';

export const useFeatureFlag = (flag: string, defaultValue?: boolean) => {
  return useSelector(selectFeatureFlags)[flag] ?? defaultValue;
};
